export enum ReporterRequestStatus {
    ToSend = 1,
    AwaitingResponse = 2,
    Answered = 3,
}
